module.exports = __webpack_public_path__ + "img/ejemplo-6-2.e4841450.jpg";